import { formatDurationLabel } from "@clipboard-health/date-time";

interface TextSegment {
  text: string;
  bold?: boolean;
}

export type CancellationProtectionDescription = TextSegment[];

export function getCancellationProtectionDescription(
  cancellationProtectionWindowInHours: number,
  isSentHomeProtected: boolean
): CancellationProtectionDescription {
  const windowText = formatDurationLabel(cancellationProtectionWindowInHours, "hour", {
    keepOriginalUnit: true,
  });

  if (cancellationProtectionWindowInHours > 0 && isSentHomeProtected) {
    return [
      {
        text: "This protection ensures you always get paid in full, when your shift is cancelled ",
      },
      { text: `within ${windowText} of shift start`, bold: true },
    ];
  }

  if (cancellationProtectionWindowInHours === 0 && isSentHomeProtected) {
    return [
      {
        text: "This protection ensures you always get paid in full, rather than partial pay, when you're sent home. However, you won't receive a payout if your shift is cancelled before start.",
      },
    ];
  }

  return [
    { text: "This protection ensures you always get paid in full, when your shift is cancelled " },
    { text: `within ${windowText} of shift start`, bold: true },
    {
      text: ". However, you won't receive a payout if you're sent home after shift starts.",
    },
  ];
}

export function getCancellationProtectionPolicyDescription(
  formattedPayAmount: string | undefined,
  cancellationProtectionWindowInHours: number,
  isSentHomeProtected: boolean
): CancellationProtectionDescription {
  const windowText = formatDurationLabel(cancellationProtectionWindowInHours, "hour", {
    keepOriginalUnit: true,
  });

  const amountSegments: CancellationProtectionDescription = formattedPayAmount
    ? [{ text: formattedPayAmount, bold: true }, { text: " " }]
    : [];

  if (cancellationProtectionWindowInHours > 0 && isSentHomeProtected) {
    return [
      { text: "You'll be paid " },
      ...amountSegments,
      {
        text: `if the workplace cancels within ${windowText} of shift start or sends you home during your shift`,
      },
    ];
  }

  if (cancellationProtectionWindowInHours === 0 && isSentHomeProtected) {
    return [
      { text: "You'll be paid " },
      ...amountSegments,
      { text: "if the workplace sends you home during your shift" },
    ];
  }

  return [
    { text: "You'll be paid " },
    ...amountSegments,
    { text: `if the workplace cancels within ${windowText} of shift start` },
  ];
}
